import React, {useRef} from 'react';
import {isAgentMessage, useLiveChatInit} from "../lib/liveChat";
import {camelizeKeys, snakeifyKeys} from "../ReduxStore/Helpers/transformObject";
import PostWithParams from "../ReduxStore/Helpers/PostWithParams";
import LocalUrlMaker from "../lib/LocalUrlMaker";

const isDev = (process.env.NODE_ENV == 'development');

/**
 * 2026-07 cleaned up, removed Redux linkage
 *
 * cart.chat_info is a first-class field in the shopping cart table, a JSON field.
 * It is used by Globex NewOrderImport and Stonecutters cart agent reports only.
 */
export default function LiveChatWatcher({cartCode}) {
  const cartCodeRef = useRef(cartCode);
  const savedToCartRef = useRef(null);

  // Update this right away.
  cartCodeRef.current = cartCode;

  useLiveChatInit(api => {
    api.on_message = handleNewMessage;

    // cleanup function for useEffect
    return () => {
      if (api.on_message === handleNewMessage)
        api.on_message = null;
    }
  });

  async function handleNewMessage(message) {
    message = camelizeKeys(message);

    const currentCart = cartCodeRef?.current;

    if (!isAgentMessage(message)) {
      return;
    }

    if (currentCart && (currentCart !== savedToCartRef.current)) {
      try {
        await saveChatInfoToCart({cartCode: currentCart, message});
        savedToCartRef.current = currentCart;
      } catch (err) {
        console.error("Failed to save chat info", err);
      }
    }
  }

  return null;
}

function saveChatInfoToCart({cartCode, message}) {
  if (!cartCode) return null;

  let post = new PostWithParams({
    method: 'PATCH',
    url: LocalUrlMaker.jsonPath(`/cart/${cartCode}.json`),
    params: {'shopping_cart[chat_info]': JSON.stringify(snakeifyKeys(message))}
  });

  return post.perform();
}

// '{"agent_name":"Otto","status":"started","chat_start_at":"2026-07-27T19:38:44.809Z",
// "url":"https://lisa.aagarage.net/Seat-Covers","persisted":false,
// "chat_id":"TI2UOM2KQG","visitor_id":"ee661ecc-8db3-4c5c-bee5-a1b2a4c38cd2"}'
